import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";
import InputMask from "react-input-mask";
import { FileUploader } from "react-drag-drop-files";
import Title from "../../components/Title";
import Button from "../../components/Button";
import { setLoading, getStageScreen } from "../../../../redux";
import { validateIncomeProof } from "../IncomeProof/redux/action";
import {
  makeid,
  THINKREDBLUE_API_URL,
  VACHANA_API_URL,
  showPrevBtnByUrl,
  showNextBtnByUrl,
  getPrevAndNextRoute,
} from "utils";
import InputTitle from "designs/v1/components/InputTitle";

const FILE_TYPES = ["JPG", "JPEG", "PNG", "PDF"];

const Nominee = () => {
  let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
  const dispatch = useDispatch();
  const history = useHistory();
  const { hasNomineeProofValidate } = useSelector((state) => state.theme);
  const { kycStatus, kycPageName } = useSelector((state) => state.navigation);
  const [nominee, setNominee] = useState();
  const [show, setShow] = useState(false);
  const [showNominee, setShowNominee] = useState(false);
  const fields = {
    id: "",
    name: "",
    email: "",
    phone: "",
    dob: "",
    relationWithApplicant: "",
    otherRelationship: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    pinCode: "",
    documentType: "",
    document: "",
    documentBack: "",
    nominee_file_type: "",
    share: "",
    isMinor: "",
    relationWithNominee: "",
    addMore: "",
    gName: "",
    gPhone: "",
    gEmail: "",
    gdob: "",
    gIdType: "",
    gIdProof: "",
    gIdProofBack: "",
    guardian_file_type: "",
    gAddress1: "",
    gAddress2: "",
    gCity: "",
    gState: "",
    gCountry: "",
    gPinCode: "",
  };
  const [values, setValues] = useState(fields);
  const [errors, setErrors] = useState(fields);
  const [isLoading, setIsLoading] = useState(false);
  const [dataSource, setdataSource] = useState([]);
  const [totalShare, setTotalShare] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [isAddressMatch, setIsAddressMatch] = useState({
    isMatch: false,
    isMatch1: false,
  });
  const [isSameAddress, setIsSameAddress] = useState();
  const minDate = new Date("01/01/1920");
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() - 18);

  const [proofOptions, setProofOptions] = useState([
    { name: "PAN", value: "PAN" },
    { name: "Aadhaar", value: "Aadhaar" },
    { name: "Driving License", value: "DrivingLicense" },
    { name: "Passport", value: "Passport" },
    { name: "Voter ID", value: "VoterID" },
    { name: "Other", value: "Other" },
  ]);

  const [isIncomePageShow, setIsIncomePageShow] = useState(false);

  const checkIfPageNeeded = () => {
    dispatch(setLoading(true));
    let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
    API_URL_NEW = API_URL_NEW
      ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    axios
      .get(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_flow.api.get_client_segment_detail`,
        headers
      )
      .then((result) => {
        let { data } = result.data;
        let isShow = false;
        for (let i in data) {
          if (data[i].segment == "Capital Market") {
            if (data[i].mcx) {
              isShow = true;
            }
            if (data[i].ncdex) {
              isShow = true;
            }
          }
          if (data[i].segment == "Currency Derivative") {
            if (data[i].bse) {
              isShow = true;
            }
            if (data[i].nse) {
              isShow = true;
            }
            if (data[i].ncdex) {
              isShow = true;
            }
            if (data[i].mcx) {
              isShow = true;
            }
            if (data[i].msei) {
              isShow = true;
            }
          }
          if (data[i].segment == "SLB") {
            if (data[i].bse) {
              isShow = true;
            }
            if (data[i].nse) {
              isShow = true;
            }
            if (data[i].ncdex) {
              isShow = true;
            }
            if (data[i].mcx) {
              isShow = true;
            }
            if (data[i].msei) {
              isShow = true;
            }
          }
          if (data[i].segment == "Commodities") {
            if (data[i].bse) {
              isShow = true;
            }
            if (data[i].nse) {
              isShow = true;
            }
            if (data[i].ncdex) {
              isShow = true;
            }
            if (data[i].mcx) {
              isShow = true;
            }
            if (data[i].msei) {
              isShow = true;
            }
          }
          if (data[i].segment == "Future and Option") {
            if (data[i].bse) {
              isShow = true;
            }
            if (data[i].nse) {
              isShow = true;
            }
            if (data[i].ncdex) {
              isShow = true;
            }
            if (data[i].mcx) {
              isShow = true;
            }
            if (data[i].msei) {
              isShow = true;
            }
          }
        }

        console.log("isShow", isShow);
        setIsIncomePageShow(isShow);
      })
      .catch((error) => {
        if (error.response?.data?.message === "No segments found in use KYC") {
          //logic here
          setIsIncomePageShow(false);
        }
      });
  };

  useEffect(() => {
    checkIfPageNeeded();
  }, []);
  const getApiUrl = () => {
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    let API_URL = "";
    if (portal_domain) {
      API_URL = portal_domain.substring(0, portal_domain.length - 1);
    }
    return API_URL;
  };

  const getApiHeader = () => {
    const token = window.sessionStorage.getItem("token");
    let headers = "";
    if (token) {
      headers = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Authorization: `Basic ${token}`,
        },
      };
    }
    return headers;
  };

  useEffect(() => {
    if (THINKREDBLUE_API_URL === getApiUrl()) {
      setProofOptions(proofOptions.slice(0, 2));
    }
  }, [proofOptions]);

  const handleClose = () => {
    setShow(false);
    setValues(fields);
    if (isEdit) {
      setIsEdit(false);
    }
    if (isView) {
      setIsView(false);
    }
  };
  const handleShow = () => setShow(true);

  const handleShowNominee = () => setShowNominee(true);

  const handleCloseNominee = () => setShowNominee(false);

  const handlePageChange = async () => {
    if (totalShare < 100) {
      return toast.error(
        `Nominee total share (${totalShare}%) is less than 100%`
      );
    }
    dispatch(setLoading(true));
    try {
      const resp = await axios.post(
        `${getApiUrl()}/api/method/kyc_customizations.apis.kyc_verification.api.submit_nominee`,
        {},
        getApiHeader()
      );
      dispatch(getStageScreen());
      dispatch(setLoading(false));
    } catch (error) {
      const { response } = error;
      console.log("err", response);
      dispatch(setLoading(false));
    }
  };

  const onRadioChange = async (e) => {
    const { value } = e.target;
    setNominee(value);
    if (value === "Yes") {
      addWishToNomineeApi(value);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues((prevValues) => {
      let updatedValues = {
        ...prevValues,
        [name]: value,
      };
      if (name === "documentType" && !value) {
        updatedValues = {
          ...updatedValues,
          document: "",
          documentBack: "",
          nominee_file_type: "",
        };
      }
      if (name === "gIdType" && !value) {
        updatedValues = {
          ...updatedValues,
          gIdProof: "",
          gIdProofBack: "",
          guardian_file_type: "",
        };
      }
      return updatedValues;
    });
    if (name === "documentType") {
      setValues((prevValues) => ({
        ...prevValues,
        document: "",
        documentBack: "",
        nominee_file_type: "",
      }));
    }
    if (name === "gIdType") {
      setValues((prevValues) => ({
        ...prevValues,
        gIdProof: "",
        gIdProofBack: "",
        guardian_file_type: "",
      }));
    }
  };

  const handleChangeInCaps = (event) => {
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value.toUpperCase(),
    });
  };

  const handleCheckInput = (event) => {
    const { name, checked } = event.target;
    setValues({
      ...values,
      [name]: checked,
    });
  };

  const handleGetAddress = async (event) => {
    const { name, checked } = event.target;
    console.log(name, checked);
    setIsSameAddress(checked);
    if (checked) {
      try {
        const resp = await axios.get(
          `${getApiUrl()}/api/method/kyc_customizations.apis.address.api.get_verified_address`,
          getApiHeader()
        );
        console.log("resp--", resp.data?.data);
        if (resp.data?.data) {
          const { address_line1, city, state, pincode } = resp.data?.data;
          const payload = {
            address1: address_line1?.toUpperCase(),
            city: city?.toUpperCase(),
            state: state?.toUpperCase(),
            pinCode: pincode,
          };
          setValues({
            ...values,
            ...payload,
          });
        }
      } catch (error) {
        const { response } = error;
        console.log("err", response);
      }
    } else {
      const payload = {
        address1: "",
        city: "",
        state: "",
        pinCode: "",
      };
      setValues({
        ...values,
        ...payload,
      });
    }
  };

  const onFileUpload = async (file, name) => {
    if (file) {
      const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
      if (!allowed_types.includes(file.type)) {
        toast.error("Only Images are allowed ( JPG | PNG | PDF )", "Error");
        return;
      }
      if (file.type === "application/pdf") {
        const fileSize = file.size / 1024 ** 2;
        if (fileSize >= 3) {
          toast.error("Please upload a file smaller than 3MB");
          return;
        }
        let isEncrypted = false;
        dispatch(setLoading(true));
        try {
          const formData = new FormData();
          formData.append("file", file, makeid(6) + ".pdf");
          const resp = await validateIncomeProof(formData);
          isEncrypted = resp.data?.message || false;
          dispatch(setLoading(false));
        } catch (error) {}
        if (isEncrypted) {
          toast.error("Please upload a file without password protected.");
          dispatch(setLoading(false));
          return;
        }
        const fileParams = { [name]: file };
        if (name === "document" || name === "documentBack") {
          fileParams["nominee_file_type"] = "pdf";
        } else {
          fileParams["guardian_file_type"] = "pdf";
        }
        setValues({
          ...values,
          ...fileParams,
        });
        return;
      }
      const fileParams = { [name]: file };
      if (name === "document" || name === "documentBack") {
        fileParams["nominee_file_type"] = "image";
      } else {
        fileParams["guardian_file_type"] = "image";
      }
      setValues({
        ...values,
        ...fileParams,
      });
    }
  };

  const handleNumKeypress = (e) => {
    if (e.which !== 0 && (e.which < 48 || e.which > 57)) {
      e.preventDefault();
    }
  };

  const convertFileToUrl = (file) => {
    let image = "";
    if (file && typeof file === Object) {
      image = URL.createObjectURL(file);
    } else if (file) {
      image = `${getApiUrl()}${file}`;
    }
    return image;
  };

  const handleShare = (event) => {
    const { name, value } = event.target;
    if (value > 100) {
      return;
    }
    setValues({
      ...values,
      [name]: value,
    });
  };

  const [showNoModal, setShowNoModal] = useState(false);
  const isShowModal = () => {
    if (API_URL_NEW == "https://consortium.brkscmcj.in/") {
      if (nominee == "No") {
        setShowNoModal(true);
      } else {
        addWishToNomineeApi(nominee);
      }
    } else {
      addWishToNomineeApi(nominee);
    }
  };

  const addWishToNomineeApi = async (nominee) => {
    if (nominee === "No") {
      dispatch(setLoading(true));
      for (const item of dataSource) {
        await handleRemoveNominee(item, false);
      }
    }
    try {
      await axios.post(
        `${getApiUrl()}/api/method/kyc_customizations.apis.kyc_verification.api.wish_to_add_nominee`,
        { wish_nominee: nominee },
        getApiHeader()
      );
      dispatch(setLoading(false));
      nominee === "No" && dispatch(getStageScreen());
    } catch {
      dispatch(setLoading(false));
    }
  };

  const addNomineeAPI = async (formVal) => {
    const values = JSON.parse(JSON.stringify(formVal), (key, value) => {
      return value === null || value === undefined ? "" : value;
    });
    let addMore = false;
    let share = isNaN(parseInt(values.share)) ? 0 : parseInt(values.share);
    if (totalShare + share < 100) {
      addMore = true;
    }
    console.log("values", values);
    const formData = new FormData();
    formData.append("nominee_name", values.name);
    formData.append("email", values.email);
    formData.append("mobile", values.phone);
    formData.append(
      "nominee_dob",
      values.dob ? moment(values.dob).format("DD-MM-YYYY") : ""
    );
    formData.append("relation_with_applicant", values.relationWithApplicant);
    formData.append("other_relationship", values.otherRelationship);
    formData.append("share_of_nominee", values.share);
    formData.append("proof_type", values.documentType);
    formData.append("proof_file", formVal.document);
    formVal.documentBack &&
      formData.append("proof_file_back", formVal.documentBack);
    formData.append("nominee_file_type", values.nominee_file_type);
    formData.append("address_line1", values.address1);
    formData.append("address_line2", values.address2);
    formData.append("city", values.city);
    formData.append("state", values.state);
    formData.append("country", values.country);
    formData.append("pincode", values.pinCode);
    if (values.isMinor) {
      formData.append("is_minor", values.isMinor);
      formData.append("guardian_dob", moment(values.gdob).format("DD-MM-YYYY"));
      formData.append("relationship_with_nominee", values.relationWithNominee);
      formData.append("guardian_name", values.gName);
      formData.append("guardian_email", values.gEmail);
      formData.append("guardian_mobile", values.gPhone);
      formData.append("id_type", values.gIdType);
      formData.append("guardian_id_proof", formVal.gIdProof);
      formVal.gIdProofBack &&
        formData.append("guardian_id_proof_back", formVal.gIdProofBack);
      formData.append("guardian_file_type", values.guardian_file_type);
      formData.append("guardian_address1", values.gAddress1);
      formData.append("guardian_address2", values.gAddress2);
      formData.append("guardian_city", values.gCity);
      formData.append("guardian_state", values.gState);
      formData.append("guardian_country", values.gCountry);
      formData.append("guardian_pincode", values.gPinCode);
    }
    if (addMore) {
      formData.append("add_more", addMore);
    }
    if (isEdit) {
      formData.append("id", values.id);
    }
    setIsLoading(true);
    dispatch(setLoading(true));
    if (isEdit) {
      try {
        const resp = await axios.post(
          `${getApiUrl()}/api/method/kyc_customizations.apis.kyc_verification.api.update_nominations`,
          formData,
          getApiHeader()
        );
        const { data } = resp?.data;
        console.log("resp update", data);
        setIsEdit(false);
        setValues(fields);
        setIsLoading(false);
        dispatch(setLoading(false));
        getNomineeAPI();
      } catch (error) {
        const { response } = error;
        console.log("err", response);
        setIsLoading(false);
        dispatch(setLoading(false));
        if (response?.data?.code === 417) {
          return toast.error(
            "Total Shares of nominee should not more than 100"
          );
        }
        toast.error(response?.data?.message || "something went wrong");
      }
    } else {
      try {
        const resp = await axios.post(
          `${getApiUrl()}/api/method/kyc_customizations.apis.kyc_verification.api.add_nominations`,
          formData,
          getApiHeader()
        );
        console.log("resp add", resp);
        setIsLoading(false);
        dispatch(setLoading(false));
        getNomineeAPI();
      } catch (error) {
        const { response } = error;
        console.log("err", response);
        setIsLoading(false);
        dispatch(setLoading(false));
        toast.error(response?.data?.message);
      }
    }
  };

  const handleSubmitNominee = async (event) => {
    event.preventDefault();
    const share = isNaN(parseInt(values.share)) ? 0 : parseInt(values.share);
    const existingShare = dataSource
      .filter(({ id }) => id !== values.id)
      .reduce((acc, item) => {
        return acc + parseInt(item.share);
      }, 0);
    const totalShare = share + existingShare;
    if (totalShare === 100) {
      handleCloseNominee();
      addNomineeAPI(values);
    } else {
      handleShowNominee();
    }
  };

  const handleAddNominee = async (type) => {
    console.log("values", values);
    let share = isNaN(parseInt(values.share)) ? 0 : parseInt(values.share);
    if (type === "yes") {
      handleCloseNominee();
      addNomineeAPI(values);
    } else {
      if (share === 100) {
        handleCloseNominee();
        addNomineeAPI(values);
      } else {
        if (isEdit) {
          const existingShare = dataSource
            .filter(({ id }) => id !== values.id)
            .reduce((acc, item) => {
              return acc + parseInt(item.share);
            }, 0);
          setValues({
            ...values,
            share: 100 - existingShare,
          });
          const _formValue = {
            ...values,
            share: 100 - existingShare,
          };
          handleCloseNominee();
          addNomineeAPI(_formValue);
          return;
        }
        let tShare = share > totalShare ? 100 - totalShare : 100 - totalShare;
        setValues({
          ...values,
          share: tShare,
        });
        const _formValue = {
          ...values,
          share: tShare,
        };
        handleCloseNominee();
        addNomineeAPI(_formValue);
        return;
      }
    }
  };

  const getFormData = (item) => {
    return {
      id: item.id,
      name: item.name,
      email: item.email,
      phone: item.phone,
      dob: item.dob,
      relationWithApplicant: item.relationWithApplicant,
      otherRelationship: item.otherRelationship,
      address1: item.address1,
      address2: item.address2,
      city: item.city,
      state: item.state,
      country: item.country,
      pinCode: item.pinCode,
      documentType: item.documentType,
      document: item.document,
      documentBack: item.documentBack,
      nominee_file_type: item.nominee_file_type,
      share: item.share,
      isMinor: item.isMinor,
      relationWithNominee: item.relationWithNominee,
      gName: item.gName,
      gPhone: item.gPhone,
      gEmail: item.gEmail,
      gdob: item.gdob,
      gIdType: item.gIdType,
      gIdProof: item.gIdProof,
      gIdProofBack: item.gIdProofBack,
      guardian_file_type: item.guardian_file_type,
      gAddress1: item.gAddress1,
      gAddress2: item.gAddress2,
      gCity: item.gCity,
      gState: item.gState,
      gCountry: item.country,
      gPinCode: item.gPinCode,
    };
  };

  const handleViewNominee = (item) => {
    handleShow();
    setIsView(true);
    setValues(getFormData(item));
    setIsSameAddress(false);
  };

  const handleEditNominee = (item) => {
    handleShow();
    setIsEdit(true);
    setValues(getFormData(item));
    setIsSameAddress(false);
  };

  const handleRemoveNominee = async (item, shouldCloseLoading = true) => {
    shouldCloseLoading && dispatch(setLoading(true));
    const formData = new FormData();
    formData.append("id", item.id);
    try {
      const resp = await axios.post(
        `${getApiUrl()}/api/method/kyc_customizations.apis.kyc_flow.api.delete_nominations`,
        formData,
        getApiHeader()
      );
      const { data } = resp?.data;
      console.log("resp", data);
      setdataSource(dataSource.filter((y) => y.id !== item.id));
      setTotalShare(totalShare - parseInt(item.share));
      setValues(fields);
      shouldCloseLoading && dispatch(setLoading(false));
    } catch (error) {
      const { response } = error;
      console.log("err", response);
      shouldCloseLoading && dispatch(setLoading(false));
    }
  };

  const getNomineeAPI = async () => {
    dispatch(setLoading(true));
    try {
      const resp = await axios.get(
        `${getApiUrl()}/api/method/kyc_customizations.apis.kyc_flow.api.get_nominations`,
        getApiHeader()
      );
      const { data } = resp?.data;
      console.log("resp", data);
      const payload = data?.nominations?.map((item) => {
        return {
          id: item.name,
          name: item.nominee_name,
          email: item.email_id,
          phone: item.mobile,
          dob:
            item.nominee_dob &&
            new Date(item.nominee_dob.split("-").reverse().join("-")),
          relationWithApplicant: item.relationship_with_applicant,
          otherRelationship: item.other_relationship,
          address1: item.address_line1,
          address2: item.address_line2 || "",
          city: item.city,
          state: item.state,
          country: item.country,
          pinCode: item.pincode,
          documentType: item.type_of_identification,
          document: item.nominee_id_proof,
          documentBack: item.nominee_id_proof_back,
          share: item.share_of__nominee,
          isMinor: item.minor === 1 ? true : false,
          relationWithNominee: item.relationship_with_nomiee,
          gName: item.guardian_name,
          gPhone: item.guardian_mobile,
          gEmail: item.guardian_email,
          gdob:
            item.guardian_dob &&
            new Date(item.guardian_dob.split("-").reverse().join("-")),
          gIdType: item.id_type,
          gIdProof: item.guardian_id_proof,
          gIdProofBack: item.guardian_id_proof_back,
          gAddress1: item.guardian_address1,
          gAddress2: item.guardian_address2,
          gCity: item.guardian_city,
          gState: item.guardian_state,
          gCountry: item.guardian_country,
          gPinCode: item.guardian_pincode,
        };
      });
      setTotalShare(data?.total_shares);
      setdataSource(payload);
      setValues(fields);
      handleClose();
      dispatch(setLoading(false));
    } catch (error) {
      const { response } = error;
      console.log("err", response);
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    getNomineeAPI();
  }, []);

  useEffect(() => {
    if (values.pinCode?.length === 6) {
      handleAddressApi(values.pinCode, false);
    } else {
      let formValue = {
        city: "",
        state: "",
        country: "",
      };
      setValues({
        ...values,
        ...formValue,
      });
      setIsAddressMatch({
        ...isAddressMatch,
        isMatch: false,
      });
    }
  }, [values.pinCode]);

  useEffect(() => {
    if (values.gPinCode?.length === 6) {
      handleAddressApi(values.gPinCode, true);
    } else {
      let formValue = {
        gCity: "",
        gState: "",
        gCountry: "",
      };
      setValues({
        ...values,
        ...formValue,
      });
      setIsAddressMatch({
        ...isAddressMatch,
        isMatch1: false,
      });
    }
  }, [values.gPinCode]);

  const handleAddressApi = async (value, bool) => {
    const payload = { pincode: value };
    try {
      const resp = await axios.post(
        `${getApiUrl()}/api/method/kyc_customizations.apis.address.api.get_data_from_pincode`,
        payload,
        getApiHeader()
      );
      let address = resp.data?.data;
      console.log("address", address);
      if (bool) {
        let formValue = {
          gCity: address?.DistrictName,
          gState: address?.StateName,
          gCountry: "INDIA",
        };
        setValues({
          ...values,
          ...formValue,
        });
        setIsAddressMatch({ ...isAddressMatch, isMatch1: true });
      } else {
        let formValue = {
          city: address?.DistrictName,
          state: address?.StateName,
          country: "INDIA",
        };
        setValues({
          ...values,
          ...formValue,
        });
        setIsAddressMatch({ ...isAddressMatch, isMatch: true });
      }
      console.log(address);
    } catch (error) {
      const { response } = error;
      console.error(response);
      if (bool) {
        setIsAddressMatch({ ...isAddressMatch, isMatch1: false });
      } else {
        setIsAddressMatch({ ...isAddressMatch, isMatch: false });
      }
    }
  };

  const getAge = (date) => {
    if (!date) return;
    const age = new Date(Date.now() - date.getTime()).getFullYear() - 1970;
    return age;
  };
  const [isRequired, setIsRequired] = useState(false);
  useEffect(() => {
    const isRequiredStorage = window.sessionStorage.getItem(
      "is_nomination_det_req"
    );
    if (isRequiredStorage == "Yes") {
      setIsRequired(true);
      setNominee("Yes");
      addWishToNomineeApi("Yes");
    } else {
      setIsRequired(false);
    }
  }, []);

  return (
    <div className="col-md-10">
      <form>
        <Title title="Nominee Details" />
        {(!nominee || totalShare !== 100 || nominee === "No") && (
          <>
            {!isRequired ? (
              <div className="form-group">
                <h5>Would you like to add nominee/s?</h5>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    name="type"
                    checked={nominee === "Yes"}
                    value="Yes"
                    onChange={onRadioChange}
                    className="custom-control-input"
                  />
                  <label className="custom-control-label mx-1">Yes</label>
                </div>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    name="type"
                    checked={nominee === "No"}
                    value="No"
                    onChange={onRadioChange}
                    className="custom-control-input"
                  />
                  <label className="custom-control-label mx-1">No</label>
                </div>
                {(!nominee || nominee === "No") && (
                  <div className="my-2 d-flex">
                    {!dataSource.length &&
                      showPrevBtnByUrl(
                        history.location.pathname,
                        kycStatus,
                        kycPageName
                      ) && (
                        <Button
                          title="Previous"
                          type="button"
                          className="mx-1"
                          handleClick={() => {
                            if (!isIncomePageShow) {
                              const route = getPrevAndNextRoute(
                                "income-proof",
                                kycPageName
                              );
                              history.push(route.prev);
                            } else {
                              history.push(kycPageName.IncomeProof);
                            }
                          }}
                        />
                      )}
                    <Button
                      type="button"
                      title="Submit"
                      className="mx-1"
                      disabled={!nominee}
                      handleClick={() => isShowModal(nominee)}
                    />
                    {!dataSource.length &&
                      showNextBtnByUrl(
                        history.location.pathname,
                        kycStatus,
                        kycPageName
                      ) && (
                        <Button
                          title="Next"
                          type="button"
                          className="mx-1"
                          handleClick={() => {
                            const route = getPrevAndNextRoute(
                              history.location.pathname.slice(1),
                              kycPageName
                            );
                            history.push(route.next);
                          }}
                        />
                      )}
                  </div>
                )}
              </div>
            ) : null}
          </>
        )}
        {nominee === "Yes" && (
          <>
            {totalShare !== 100 && (
              <div
                className={`my-3 d-flex ${
                  dataSource.length > 0 && "justify-content-end"
                }`}
              >
                {!dataSource.length &&
                  showPrevBtnByUrl(
                    history.location.pathname,
                    kycStatus,
                    kycPageName
                  ) && (
                    <Button
                      title="Previous"
                      type="button"
                      className="mx-1"
                      handleClick={() => {
                        if (!isIncomePageShow) {
                          const route = getPrevAndNextRoute(
                            history.location.pathname.slice(1),
                            kycPageName
                          );
                          history.push(route.prev);
                        } else {
                          history.push(kycPageName.IncomeProof);
                        }
                      }}
                    />
                  )}
                <Button
                  type="button"
                  title="Add Nominee"
                  handleClick={() => {
                    setIsSameAddress(false);
                    handleShow();
                  }}
                />
                {/* {!dataSource.length &&
                  showNextBtnByUrl(history.location.pathname, kycStatus, kycPageName) && (
                    <Button
                      title="Next"
                      type="button"
                      className="mx-1"
                      handleClick={() =>
                        history.push(kycPageName.BankVerification)
                      }
                    />
                  )} */}
              </div>
            )}
            {dataSource.length > 0 && (
              <>
                <div className="table-responsive mt-2">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Date of birth</th>
                        <th scope="col">Relationship</th>
                        <th scope="col">Share(%)</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataSource.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.name}</td>
                            <td>{item.phone}</td>
                            <td>
                              {item.dob
                                ? moment(item.dob).format("DD-MM-YYYY")
                                : ""}
                            </td>
                            <td>{item.relationWithApplicant}</td>
                            <td>{item.share}</td>
                            <td>
                              <div className="d-flex">
                                <button
                                  type="button"
                                  className="btn btn-success mx-1"
                                  onClick={() => handleViewNominee(item)}
                                >
                                  <i className="fa fa-eye"></i>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-success mx-1"
                                  onClick={() => handleEditNominee(item)}
                                >
                                  <i className="fa fa-pencil"></i>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-danger mx-1"
                                  onClick={() => handleRemoveNominee(item)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex my-1">
                  {showPrevBtnByUrl(
                    history.location.pathname,
                    kycStatus,
                    kycPageName
                  ) && (
                    <Button
                      title={"Previous"}
                      type="button"
                      className="mx-1"
                      handleClick={() => {
                        if (!isIncomePageShow) {
                          const route = getPrevAndNextRoute(
                            history.location.pathname.slice(1),
                            kycPageName
                          );
                          history.push(route.prev);
                        } else {
                          history.push(kycPageName.IncomeProof);
                        }
                      }}
                    />
                  )}
                  <Button
                    type="button"
                    title="Submit"
                    handleClick={() => handlePageChange()}
                  />
                  {showNextBtnByUrl(
                    history.location.pathname,
                    kycStatus,
                    kycPageName
                  ) &&
                    totalShare === 100 && (
                      <Button
                        title="Next"
                        type="button"
                        className="mx-1"
                        handleClick={() => {
                          const route = getPrevAndNextRoute(
                            history.location.pathname.slice(1),
                            kycPageName
                          );
                          history.push(route.next);
                        }}
                      />
                    )}
                </div>
              </>
            )}
          </>
        )}
      </form>

      <Modal
        size="lg"
        backdrop="static"
        keyboard={false}
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isEdit ? "Edit" : isView ? "View" : "Add"} Nominee
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            name="form"
            onSubmit={handleSubmitNominee}
          >
            <div className="row my-1">
              <div className="col-md-6">
                <InputTitle
                  title={"Name"}
                  isRequired={true}
                />

                <input
                  type="text"
                  name="name"
                  value={values.name}
                  onChange={handleChangeInCaps}
                  className="form-control"
                  disabled={isView}
                  maxLength={200}
                  required
                />
              </div>
              <div className="col-md-6">
                <InputTitle title={"Email"} />
                <input
                  type="text"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  className="form-control"
                  disabled={isView}
                  maxLength={50}
                />
              </div>
            </div>
            <div className="row my-1">
              <div className="col-md-6">
                <InputTitle
                  title={"Phone"}
                  isRequired={true}
                />
                <input
                  type="text"
                  name="phone"
                  value={values.phone}
                  onKeyPress={handleNumKeypress}
                  onChange={handleChange}
                  className="form-control"
                  maxLength={10}
                  minLength={10}
                  disabled={isView}
                  required
                />
              </div>
              <div className="col-md-6">
                <InputTitle
                  title={"Date Of Birth"}
                  isRequired={getApiUrl() !== VACHANA_API_URL}
                />
                <div>
                  <DatePicker
                    name="dob"
                    placeholderText="dd/mm/yyyy"
                    dateFormat="dd/MM/yyyy"
                    selected={values.dob}
                    onChange={(date) => {
                      setValues({
                        ...values,
                        dob: date,
                        isMinor: getAge(date) < 18,
                      });
                    }}
                    customInput={
                      <InputMask
                        style={{ width: "100%" }}
                        mask="99/99/9999"
                      />
                    }
                    maxDate={new Date()}
                    minDate={minDate}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className="form-control"
                    disabled={isView}
                    required={getApiUrl() !== VACHANA_API_URL}
                    isClearable={!isView}
                  />
                </div>
              </div>
            </div>
            <div className="row my-1">
              <div className="col-md-6">
                <InputTitle
                  title={"Relation With Applicant"}
                  isRequired={true}
                />
                <select
                  className="form-select"
                  name="relationWithApplicant"
                  value={values.relationWithApplicant}
                  onChange={handleChange}
                  disabled={isView}
                  required
                >
                  <option value="">Select</option>
                  <option>FATHER</option>
                  <option>MOTHER</option>
                  <option>BROTHER</option>
                  <option>SISTER</option>
                  <option>SON</option>
                  <option>DAUGHTER</option>
                  <option>SPOUSE</option>
                  <option>OTHERS</option>
                </select>
              </div>
              {values.relationWithApplicant === "OTHERS" && (
                <div className="col-md-6">
                  <InputTitle
                    title={"Relationship with Applicant"}
                    isRequired={true}
                  />
                  <input
                    type="text"
                    name="otherRelationship"
                    value={values.otherRelationship}
                    onChange={handleChangeInCaps}
                    className="form-control"
                    disabled={isView}
                    required={values.relationWithApplicant === "OTHERS"}
                  />
                </div>
              )}
            </div>
            <div className="form-check my-2">
              <input
                className="form-check-input"
                type="checkbox"
                checked={isSameAddress}
                value={isSameAddress}
                onChange={handleGetAddress}
                disabled={isView}
              />
              <label className="form-check-label">
                Same as address of applicant
              </label>
            </div>
            <div className="form-group row my-1">
              <div className="col-md-6">
                <InputTitle
                  title={"Address Line 1"}
                  isRequired={true}
                />
                <textarea
                  type="text"
                  className="form-control"
                  name="address1"
                  value={values.address1}
                  onChange={handleChangeInCaps}
                  disabled={isView}
                  required
                ></textarea>
              </div>
              <div className="col-md-6">
                <InputTitle title={"Address Line 2"} />
                <textarea
                  type="text"
                  className="form-control"
                  name="address2"
                  value={values.address2}
                  onChange={handleChangeInCaps}
                  disabled={isView}
                ></textarea>
              </div>
            </div>
            <div className="form-group row my-1">
              <div className="col-md-6">
                <InputTitle
                  title={"Pincode"}
                  isRequired={true}
                />
                <input
                  type="text"
                  className="form-control"
                  name="pinCode"
                  value={values.pinCode}
                  onKeyPress={handleNumKeypress}
                  onChange={handleChange}
                  disabled={isView}
                  maxLength={6}
                  required
                />
              </div>
            </div>
            <div className="form-row my-1">
              <div className="form-group row">
                <div className="col-md-6">
                  <InputTitle
                    title={"City"}
                    isRequired={true}
                  />
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    value={values.city}
                    onChange={handleChangeInCaps}
                    disabled={isView || isAddressMatch.isMatch}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <InputTitle
                    title={"State"}
                    isRequired={true}
                  />
                  <input
                    type="text"
                    className="form-control"
                    name="state"
                    value={values.state}
                    onChange={handleChangeInCaps}
                    disabled={isView || isAddressMatch.isMatch}
                    required
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-6">
                  <InputTitle
                    title={"Country"}
                    isRequired={true}
                  />
                  <select
                    className="form-select"
                    name="country"
                    value={values.country}
                    onChange={handleChangeInCaps}
                    disabled={isView || isAddressMatch.isMatch}
                    required
                  >
                    <option value="">Choose...</option>
                    <option value={"INDIA"}>India</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 my-1">
                <label>
                  <InputTitle
                    title={"Proof Type"}
                    isRequired={hasNomineeProofValidate === "Yes"}
                  />
                </label>
                <select
                  className="form-select"
                  name="documentType"
                  value={values.documentType}
                  onChange={handleChange}
                  disabled={isView}
                  required={
                    hasNomineeProofValidate === "Yes"
                      ? true
                      : values.document && !values.documentType
                  }
                >
                  <option value="">Select Proof Type</option>
                  {proofOptions.map((proof) => (
                    <option
                      key={proof.value}
                      value={proof.value}
                    >
                      {proof.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6 my-1">
                <div className="d-flex align-items-center justify-content-between">
                  <InputTitle title={"Front Proof"} />
                  <div className="file_limit_text">Maximum file size: 4 MB</div>
                </div>
                <div className="file-uploader-container">
                  <FileUploader
                    key={values.document}
                    handleChange={(file) => onFileUpload(file, "document")}
                    name="file"
                    types={FILE_TYPES}
                    disabled={isView}
                    required={values.documentType && !values.document}
                  />
                </div>
                {/* <input
                  key={values.document}
                  type="file"
                  accept="image/*,application/pdf"
                  onChange={(e) => onFileUpload(e, "document")}
                  className="form-control"
                  disabled={isView}
                  required={values.documentType && !values.document}
                /> */}
                {/* <label className="my-1 text-muted text-sm">
                  <small>Maximum file size: 4 MB</small>
                </label> */}
                {values.document?.name && (
                  <p>
                    <small>File name: {values.document?.name}</small>
                  </p>
                )}
                {/* {isView && (
                <img src={convertFileToUrl(values.document)} width="200" />
              )} */}
              </div>
            </div>
            <div className="row">
              {values.documentType && values.documentType !== "PAN" && (
                <div className="col-md-6 my-1">
                  <div className="d-flex align-items-center justify-content-between">
                    <InputTitle title={"Back Proof"} />
                    <div className="file_limit_text">
                      Maximum file size: 4 MB
                    </div>
                  </div>
                  <div className="file-uploader-container">
                    <FileUploader
                      key={values.documentBack}
                      handleChange={(file) =>
                        onFileUpload(file, "documentBack")
                      }
                      name="file"
                      types={FILE_TYPES}
                      disabled={isView}
                      required={
                        values.documentType === "Other"
                          ? false
                          : values.documentType && !values.documentBack
                      }
                    />
                  </div>
                  {/* <input
                    key={values.documentBack}
                    type="file"
                    accept="image/*,application/pdf"
                    onChange={(e) => onFileUpload(e, "documentBack")}
                    className="form-control"
                    disabled={isView}
                    required={
                      values.documentType === "Other"
                        ? false
                        : values.documentType && !values.documentBack
                    }
                  /> */}
                  {/* <label className="my-1 text-muted text-sm">
                    <small>Maximum file size: 4 MB</small>
                  </label> */}
                  {values.documentBack?.name && (
                    <p>
                      <small>File name: {values.documentBack?.name}</small>
                    </p>
                  )}
                </div>
              )}
            </div>
            <div className="row my-1">
              <div className="col-md-6">
                <InputTitle
                  title={"Allocation of shares (%)"}
                  isRequired={true}
                />
                <input
                  type="text"
                  name="share"
                  value={values.share}
                  onKeyPress={handleNumKeypress}
                  onChange={handleShare}
                  className="form-control"
                  maxLength={3}
                  disabled={isView}
                  required
                />
              </div>
              <div className="col-md-6">
                <div className="mt-4 d-flex">
                  <label className="form-check-label">Is Minor</label>
                  <input
                    className="form-check mx-2"
                    name="isMinor"
                    type="checkbox"
                    checked={values.isMinor || getAge(values.dob) < 18}
                    value={values.isMinor}
                    onChange={handleCheckInput}
                    disabled={isView || getAge(values.dob) < 18}
                  />
                </div>
              </div>
            </div>
            {values.isMinor && (
              <div className="mt-4">
                <h5 className="my-2">Guardian Details</h5>
                <hr />
                <div className="row my-1">
                  <div className="col-md-6">
                    <InputTitle
                      title={"Name"}
                      isRequired={true}
                    />
                    <input
                      type="text"
                      name="gName"
                      value={values.gName}
                      onChange={handleChangeInCaps}
                      className="form-control"
                      disabled={isView}
                      maxLength={200}
                      required={values.isMinor}
                    />
                  </div>
                  <div className="col-md-6">
                    <InputTitle title={"Email"} />
                    <input
                      type="text"
                      name="gEmail"
                      value={values.gEmail}
                      onChange={handleChange}
                      className="form-control"
                      disabled={isView}
                      maxLength={50}
                    />
                  </div>
                </div>
                <div className="row my-1">
                  <div className="col-md-6">
                    <InputTitle
                      title={"Phone"}
                      isRequired={true}
                    />
                    <input
                      type="text"
                      name="gPhone"
                      value={values.gPhone}
                      onKeyPress={handleNumKeypress}
                      onChange={handleChange}
                      className="form-control"
                      maxLength={10}
                      minLength={10}
                      disabled={isView}
                      required={values.isMinor}
                    />
                  </div>
                  <div className="col-md-6">
                    <InputTitle
                      title={"Date Of Birth"}
                      isRequired={true}
                    />
                    <div>
                      <DatePicker
                        name="gdob"
                        placeholderText="dd/mm/yyyy"
                        dateFormat="dd/MM/yyyy"
                        selected={values.gdob}
                        onChange={(date) => {
                          setValues({
                            ...values,
                            ["gdob"]: date,
                          });
                        }}
                        customInput={
                          <InputMask
                            style={{ width: "100%" }}
                            mask="99/99/9999"
                          />
                        }
                        maxDate={maxDate}
                        minDate={minDate}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control"
                        disabled={isView}
                        required={values.isMinor}
                        isClearable={!isView}
                      />
                    </div>
                  </div>
                </div>
                <div className="row my-1">
                  <div className="col-md-6">
                    <InputTitle title={"Relation With Nominee"} />
                    <select
                      className="form-select"
                      name="relationWithNominee"
                      value={values.relationWithNominee}
                      onChange={handleChange}
                      disabled={isView}
                    >
                      <option value="">Select</option>
                      <option>FATHER</option>
                      <option>MOTHER</option>
                      <option>BROTHER</option>
                      <option>SISTER</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <InputTitle
                      title={"Proof Type"}
                      isRequired={hasNomineeProofValidate === "Yes"}
                    />
                    <select
                      className="form-select"
                      name="gIdType"
                      value={values.gIdType}
                      onChange={handleChange}
                      disabled={isView}
                      required={
                        hasNomineeProofValidate === "Yes"
                          ? true
                          : values.gIdProof && !values.gIdType
                      }
                    >
                      <option value="">Select Proof Type</option>
                      {proofOptions.map((proof) => (
                        <option
                          key={proof.value}
                          value={proof.value}
                        >
                          {proof.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 my-1">
                    <div className="d-flex align-items-center justify-content-between">
                      <InputTitle title={"Front Proof"} />
                      <div className="file_limit_text">
                        Maximum file size: 4 MB
                      </div>
                    </div>
                    <div className="file-uploader-container">
                      <FileUploader
                        key={values.gIdProof}
                        handleChange={(file) => onFileUpload(file, "gIdProof")}
                        name="file"
                        types={FILE_TYPES}
                        disabled={isView}
                        required={values.gIdType && !values.gIdProof}
                      />
                    </div>
                    {/* <input
                      key={values.gIdProof}
                      type="file"
                      accept="image/*,application/pdf"
                      onChange={(e) => onFileUpload(e, "gIdProof")}
                      className="form-control"
                      disabled={isView}
                      required={values.gIdType && !values.gIdProof}
                    /> */}
                    {/* <label className="my-1 text-muted text-sm">
                      <small>Maximum file size: 4 MB</small>
                    </label> */}
                    {values.gIdProof?.name && (
                      <p>
                        <small>File name: {values.gIdProof?.name}</small>
                      </p>
                    )}
                    {/* {isView && (
                    <img src={convertFileToUrl(values.gIdProof)} width="200" />
                  )} */}
                  </div>
                  {values.gIdType && values.gIdType !== "PAN" && (
                    <div className="col-md-6 my-1">
                      <div className="d-flex align-items-center justify-content-between">
                        <InputTitle title={"Back Proof"} />
                        <div className="file_limit_text">
                          Maximum file size: 4 MB
                        </div>
                      </div>
                      <div className="file-uploader-container">
                        <FileUploader
                          key={values.gIdProofBack}
                          handleChange={(file) =>
                            onFileUpload(file, "gIdProofBack")
                          }
                          name="file"
                          types={FILE_TYPES}
                          disabled={isView}
                          required={
                            values.gIdType === "Other"
                              ? false
                              : values.gIdType && !values.gIdProofBack
                          }
                        />
                      </div>
                      {/* <input
                        key={values.gIdProofBack}
                        type="file"
                        accept="image/*,application/pdf"
                        onChange={(e) => onFileUpload(e, "gIdProofBack")}
                        className="form-control"
                        disabled={isView}
                        required={
                          values.gIdType === "Other"
                            ? false
                            : values.gIdType && !values.gIdProofBack
                        }
                      /> */}
                      {/* <label className="my-1 text-muted text-sm">
                        <small>Maximum file size: 4 MB</small>
                      </label> */}
                      {values.gIdProofBack?.name && (
                        <p>
                          <small>File name: {values.gIdProofBack?.name}</small>
                        </p>
                      )}
                    </div>
                  )}
                </div>
                <div className="form-row my-1">
                  <div className="form-group row">
                    <div className="col-md-6">
                      <InputTitle
                        title={"Address  Line 1"}
                        isRequired={true}
                      />
                      <textarea
                        type="text"
                        className="form-control"
                        name="gAddress1"
                        value={values.gAddress1}
                        onChange={handleChangeInCaps}
                        disabled={isView}
                        required={values.isMinor}
                      ></textarea>
                    </div>
                    <div className="col-md-6">
                      <InputTitle title={"Address Line 2"} />
                      <textarea
                        type="text"
                        className="form-control"
                        name="gAddress2"
                        value={values.gAddress2}
                        onChange={handleChangeInCaps}
                        disabled={isView}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="form-group row my-1">
                  <div className="col-md-6">
                    <InputTitle
                      title={"Pincode"}
                      isRequired={true}
                    />
                    <input
                      type="text"
                      className="form-control"
                      name="gPinCode"
                      value={values.gPinCode}
                      onKeyPress={handleNumKeypress}
                      onChange={handleChange}
                      disabled={isView}
                      maxLength={6}
                      required={values.isMinor}
                    />
                  </div>
                </div>
                <div className="form-row my-1">
                  <div className="form-group row">
                    <div className="col-md-6">
                      <InputTitle
                        title={"City"}
                        isRequired={true}
                      />
                      <input
                        type="text"
                        className="form-control"
                        name="gCity"
                        value={values.gCity}
                        onChange={handleChangeInCaps}
                        disabled={isView || isAddressMatch.isMatch1}
                        required={values.isMinor}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputTitle
                        title={"State"}
                        isRequired={true}
                      />
                      <input
                        type="text"
                        className="form-control"
                        name="gState"
                        value={values.gState}
                        onChange={handleChangeInCaps}
                        disabled={isView || isAddressMatch.isMatch1}
                        required={values.isMinor}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <InputTitle
                        title={"Country"}
                        isRequired={true}
                      />
                      <select
                        className="form-select"
                        name="gCountry"
                        value={values.gCountry}
                        onChange={handleChangeInCaps}
                        disabled={isView || isAddressMatch.isMatch1}
                        required={values.isMinor}
                      >
                        <option value="">Choose...</option>
                        <option value={"INDIA"}>India</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="row justify-content-end my-2">
              <div style={{ display: "flex", justifyContent: "end" }}>
                <div className="mx-1">
                  <Button
                    type="button"
                    title="Cancel"
                    disabled={isLoading}
                    handleClick={handleClose}
                  />
                </div>
                {!isView && (
                  <div className="mx-1">
                    <Button
                      type="submit"
                      title={
                        isEdit
                          ? "Update"
                          : values.share === "100"
                          ? "Submit"
                          : "Add"
                      }
                      disabled={isLoading}
                    />
                  </div>
                )}
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {/* nominee modal */}
      <Modal
        backdrop="static"
        keyboard={false}
        show={showNominee}
        onHide={handleCloseNominee}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h5>Do you want to add another nominee?</h5>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger mx-1"
            onClick={() => handleAddNominee("no")}
          >
            No
          </button>
          <button
            type="button"
            className="btn btn-success mx-1"
            onClick={() => handleAddNominee("yes")}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        show={showNoModal}
        onHide={() => setShowNoModal(false)}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <strong>
            Are you sure you want to proceed without adding a nominee?
          </strong>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger mx-1"
            onClick={() => setShowNoModal(false)}
          >
            No
          </button>
          <button
            type="button"
            className="btn btn-success mx-1"
            onClick={() => addWishToNomineeApi(nominee)}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Nominee;
